module.exports = __webpack_public_path__ + "img/come-together.43b00a59.png";